import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';
import { PersonTableRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';


export type PersonTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PersonTableProps) => {
  const params = useParams();
  const { data } = ds.useQuery({
    filter: {
      projectId: params.projectId ?? ''
    }
  });
  const headers = [
    'Name',
    'Invited On',
    'Phone',
    'Email',
    'Status'
  ];

  const rows = useMemo(() => {
    return data.filter((node) => node.fullName.length >= 3).map((node, i) => (

      <PersonTableRow.FC
        key={`${i}${node.id}`}
        {...node}
      />
    ));
  }
  , [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />
  );
};
